import { Component, Input, OnInit, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppMainService } from "../../../../app-main.service";
import { ConfirmationService, MessageService } from "primeng/api";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { Subject, forkJoin, of, takeUntil } from "rxjs";
import { catchError } from "rxjs/operators";
import { ProductDataService } from "src/app/modules/shared/services/product-data.service";
import { AppMainComponent } from "src/app/app.main.component";
import { ProductsService } from "src/app/inventory/products/products.service";
import { AddYearPipe } from "src/app/shared/pipes/add-year.pipe";
import data from "src/app/inventory/staticJSON/settings-column.json";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { FinanceService } from "src/app/finance/finance.service";
import { FinanceUtilityService } from "src/app/finance/util/finance-utility.service";
import { ListService } from "src/app/configurations/inventory/custom/list/list.service";
import { ObjectNames } from "src/app/configurations/inventory/constants/constants";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";
import { CompanyBranchService } from "src/app/configurations/company-branch/company-branch.service";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { Severity, Status } from "src/app/inventory/constants/constants";
import { ICustomAtributes, IVendorCredit, IVendorCreditExpense, IVendorCreditProduct } from "src/app/inventory/purchases/vendor-credit/model/vendor-credit.model";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { UtilsService } from "src/app/inventory/purchases/utility/utils.service";
import { OverlayPanel } from "primeng/overlaypanel";
import { AccountsTransactionType } from "src/app/finance/constants/constants";
import { TabHeaderConst } from "src/app/inventory/sales-order/constants/constants";
import { IPostingPeriodDetails } from "../posting-period-selector/models/posting-period.model";
import { TaxSelectionModel } from "../tax-selection-modal/models/tax.model";

@Component({
    selector: "app-vendor-credit-add-edit",
    templateUrl: "./vendor-credit-add-edit.component.html",
    styleUrls: ["./vendor-credit-add-edit.component.scss"],
})
export class VendorCreditAddEditComponent implements OnInit, OnChanges, OnDestroy {
    @Input() displayVendorCreditAddEditDialog: boolean = false;
    @Input() selectedVendorCreditId: number = 0;
    @Input() vendorCreditDialogHeader: string;
    @Input() dialogType: string;
    @Input() orgCurrency: any;
    length: number = 0;
    qtyFractionDigits: number = 0;
    measurementUnits: any[] = [];
    decimalPlacesMap: { [key: number]: number } = {};
    allVendors: any[] = [];
    allLocationsDD = [];
    allShippingTerms = [];
    vendorCreditTemplate;
    allDiscounts = [];
    valueOptions = [];
    baseCurrency;
    allFOBPoints = [];
    trackingOptions = [];
    previousExchangeRate: number = 0;
    reCalculateNotEnabled: boolean = false;
    isAllowPostingPeriod: boolean = false;
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;
    @ViewChild("op", { static: false }) panel;
    @ViewChild('editCurrency') overlayPanel: OverlayPanel;

    @Output() onCloseVendorCreditDialog = new EventEmitter();
    @Output() onDeleteVendorCredit = new EventEmitter();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    /** Vendor Address and contact */
    allVendorsDD: any[] = [];
    vendorDetails;
    ordersVendor;
    activeVendorAddresses: any[] = [];
    ordersVendorAddrNew = "";
    ordersVendorCityNew = "";
    ordersVendorStateNew = "";
    ordersVendorCountryNew = "";
    ordersVendorZipcodeNew = "";
    ordersVendorPhoneNew = "";
    ordersVendorContactNew = "";
    statementMessege: string = "";
    closingDate: any;
    displayVendorAddress = false;
    selectedVendorAddress;
    shipAddress = null;
    isDisabled: boolean = false;
    minimumDate = new Date();
    selectedVendorContact = null;
    displayVendorContact: boolean = false;
    selectedVendorDD = null;

    /** Section options */
    vendorPaymentTermsDD: any[] = [];
    vendorShippingMethodsDD: any[] = [];
    vendorPaymentMethodsDD: any[] = [];
    salesRep: any[] = [];

    /** Form */
    vendorCreditForm: FormGroup;
    accountForm: FormGroup;

    /** Expense */
    addExpenseFlag: boolean = true;
    expenses = [];
    items = [];
    selectedTBChannel;
    index = 0;
    displayAddExpense = false;
    expenseHeader;
    // creditAmount: number;
    amountExpense: number = 0;
    financialAccounts = [];

    /** Product */
    productChannels = [];
    subTotal: number = 0;
    discount: number = 0;
    discountRate: number = 0;
    selectedValueOption: any = null;
    shippingAmount: number = 0;
    amountItem: number = 0;
    appValue;
    pageNumber: number = 1;
    pageSize: number = 15;
    rowsPerPage = [15, 30, 50, 100];
    rowsPerPageTB = [100, 200, 300, 500];
    productGlobalFilterInput: string = "";
    selectedProductsList: any[] = [];
    displayProductsTb = false;
    allProducts: any[] = [];
    allProductsData: any[] = [];
    noCaseFindOrLoadingText = "";
    bundleData2: any[] = [];
    productsData2: any[] = [];
    serviceData2: any[] = [];
    nonInventoryData2: any[] = [];
    allBundleData2: any[] = [];
    productsData: any[] = [];
    productsTB: any[] = [];
    productsTBCol: any[] = [];
    allNonInventoryData2: any[] = [];
    totalTBRecord = 0;
    allProducts2: any[] = [];
    allProductsData2: any[] = [];
    allServiceData2: any[] = [];
    selectedBundle;
    first: number = 0;
    isBundle: boolean = false;
    searchValue: string = "";
    selectedProductForScan;
    nameLists = [];
    autoGenerateLists = [];
    listLength: number = 0;
    savedOptionSelection;
    scanedProductsList = [];

    /** Tracking */
    displayScanInfo: boolean = false;
    disabledSave: boolean = false;
    allChecked: boolean = false;
    trackingForm: FormGroup;
    isPrefix: boolean = false;
    isAutoGenerated: boolean = false;
    prefixValue: string = "";
    displayImport = false;
    refId: string = '';
    importCount: number = 0;
    systemTrackingData = [];

    vendorCreditDetails: any;

    allModules: any[] = [];
    allClass: any[] = [];

    /** Custom Fields */
    customFieldData: any[] = [];
    allCustomFields: any[] = [];
    customAtributes: ICustomAtributes = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files

    /** Search Location */
    searchQuery: string = "";
    filteredLocation: any[] = [];
    minDate: Date = new Date(1988, 0, 1);
    maxDate: Date = new Date(2050, 11, 31);

    transactionTypeIds = AccountsTransactionType;
    glApiCall: boolean = false;
    TabHeaderConst = TabHeaderConst;
    @Input() visibleFromModule;
    /**tax**/
    taxSettings: any;
    taxConfig: any;
    allTaxRates: any[] = []; // account based taxes
    displayTaxSelectionDialog: boolean = false;
    selectedTax: any;
    appliedTax: any;
    currentProduct: any;
    currentProductType: string;
    taxDialogContext: 'product' | 'footer' | null = null;
    footerTaxEnabled: boolean = false;
    lineTotal = 0;
    tax = 0;
    constructor(
        private appMainService: AppMainService,
        private purchaseService: PurchasesService,
        private productDataService: ProductDataService,
        private fb: FormBuilder,
        private app: AppMainComponent,
        public utilService: UtilsService,
        private titlecasePipe: TitleCasePipe,
        private productsService: ProductsService,
        private addyearPipe: AddYearPipe,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private salesOrderService: SalesOrderService,
        private financeService: FinanceService,
        private financeUtilityService: FinanceUtilityService,
        private customfieldService: ListService,
        public datepipe: DatePipe,
        private utilityService: UtilityService, private importService: ImportserialService, private companyService: CompanyBranchService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.displayVendorCreditAddEditDialog?.currentValue) {
            this.displayVendorCreditAddEditDialog = changes.displayVendorCreditAddEditDialog.currentValue;
            this.loadInitialData();
            this.getIsetting();
        }
        if (changes?.selectedVendorCreditId?.currentValue) {
            this.selectedVendorCreditId = changes.selectedVendorCreditId.currentValue;
        }
        if (this.dialogType == 'CREATE') {
            this.closingDate = this.app._showDateTimeWithZone(new Date());
        }
    }

    ngOnInit() {
        this.initFormData();
        // this.getTaxByAddress();
        this.prepareTrackingForm();
        this.getDesimalValue();
        this.getQtyDecimalDigits();
        this.fetchUnitOfMeasureCategories();
        this.getProductsChannels("Product Type");
    }

    editVendorCredit(e) {
        this.vendorCreditDialogHeader = "Edit Vendor Credit";
        this.dialogType = 'EDIT';
        this.vendorCreditForm.enable();
    }

    getDesimalValue() {
        this.importService.getDecimalValue().subscribe((value) => {
            if (value) {
                this.length = value;
            }
        });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    fetchUnitOfMeasureCategories() {
        this.salesOrderService.fetchUnitOfMeasureCategories().subscribe(resp => {
            this.measurementUnits = resp

        })
    }
    setAdditionalDiscounts(addDiscounts) {
        if (addDiscounts && addDiscounts.length > 0) {
            this.allDiscounts = addDiscounts?.map((l) => ({ ...l, additionalDescription: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
            this.selectedValueOption = null;
        }
    }
    getBaseCurrency(CurrenciesData) {
        if (CurrenciesData?.length) {
            this.baseCurrency = CurrenciesData.filter((r) => r.isBaseCurrency)[0];

            if (this.baseCurrency?.symbol) {
                this.baseCurrency.symbol = this.baseCurrency.symbol.trim();
            }
        }
    }
    getDecimalPlacesCached(categoryId: number): number {
        if (!(categoryId in this.decimalPlacesMap)) {
            this.decimalPlacesMap[categoryId] = this.getDecimalPlaces(categoryId);
        }
        return this.decimalPlacesMap[categoryId];
    }
    getDecimalPlaces(categoryId: number): number {
        return this.measurementUnits?.some(unit => unit.id === categoryId && unit.name?.toLowerCase() === 'count') ? 0 : this.qtyFractionDigits;
    }

    getAllLocations(locationData) {
        this.allLocationsDD = locationData.reduce((acc, loc) => {
            if (loc.statusId === Status.Active) {
                acc.push({
                    ...loc,
                    customName: `${loc.name} - ${loc.locationId}`,
                });
            }
            return acc;
        }, []);
        this.filteredLocation = this.allLocationsDD;

    }

    checkSameState() {
        if (this.ordersVendorCountryNew.toLocaleLowerCase() == this.shipAddress?.address?.country?.name?.toLowerCase()
            && this.ordersVendorStateNew?.toLowerCase() == this.shipAddress?.address?.state?.name?.toLowerCase()) {
            return true;
        }
        return false;
    }

    initFormData() {
        this.vendorCreditForm = this.fb.group({
            id: [0],
            vendorId: [0, [Validators.required]],
            class: [null],
            paymentTermId: [0],
            paymentMethodId: [0],
            shippingTermId: [0],
            shippingMethodId: [null],
            userId: [0],
            contactId: [null],
            shippingAddressId: [null],
            referenceNumber: [""],
            creditAmount: [null, [Validators.required]],
            vendorCreditDate: [new Date()],
            dueDate: [0],
            note: [""],
        });

        this.prepareExpenseForm();
    }
    prepareExpenseForm() {
        this.accountForm = this.fb.group({
            id: [0],
            financialAccountId: [null, [Validators.required]],
            totalAmount: [0, [Validators.required]],
            class: [null],
            memo: [""],
        });
    }

    async loadCustomFields(id) {
        this.customfieldService.getAllCustomFields(id).then((response) => {
            this.customFieldData = [];
            this.allCustomFields = [];
            const fields = response?.filter((el) => el.section?.typeName == "Vendor Credit");
            if (fields && fields.length > 0) {
                for (let l of fields) {
                    let isChecked = this.vendorCreditTemplate?.[l.section.code]?.find((el) => el.id == l.id && el.sectionId == l.section.id)?.isChecked;
                    if (isChecked) {
                        let eachRecord = {
                            id: Number(l.id + ""),
                            name: l?.name ?? "",
                            labelname: this.vendorCreditTemplate?.[l.section.code]?.find((el) => el.id == l.id && el.sectionId == l.section?.id)?.labelname,
                            module: this.allModules.find((el) => el.id == l.objectId)?.name,
                            formControl: l.formControl,
                            formControlId: l.formControlId,
                            isRequired: l.isRequired,
                            statusId: l.statusId,
                            statusName: l?.status?.name ?? "",
                            section: l.section,
                            configurationId: l.configurationId,
                            isEdit: l.isEdit,
                            isDelete: l.isDelete,
                            pickupList: l.pickListValues ? JSON.stringify(l.pickListValues) : l.pickListValues,
                            customUploadedFiles: [],
                        };
                        this.customFieldData.push(eachRecord);
                    }
                }
            }
            this.allCustomFields = this.customFieldData;
            this.customAtributes.billing_address_item = this.allCustomFields.filter((el) => el.section?.code == "labels_billaddress");
            this.customAtributes.shipping_address_item = this.allCustomFields.filter((el) => el.section?.code == "labels_shipaddress");
            this.customAtributes.misc_item = this.allCustomFields.filter((el) => el.section?.code == "labels_misc");
            this.customAtributes.message_item = this.allCustomFields.filter((el) => el.section?.code == "labels_message");
            this.customAtributes.other1_item = this.allCustomFields.filter((el) => el.section?.code == "labels_vendorcredit_other1");
            this.customAtributes.other2_item = this.allCustomFields.filter((el) => el.section?.code == "labels_vendorcredit_other2");
            this.customAtributes.other3_item = this.allCustomFields.filter((el) => el.section?.code == "labels_vendorcredit_other3");
        });
    }

    loadInitialData() {
        this.appMainService.isShowSpinner("loadData");
        const locationObservable = this.purchaseService.getAllLocations().pipe(catchError((error) => this.handleError("location", error)));
        const CurrenciesObservable = this.companyService.getAllCurrencies().pipe(catchError((error) => this.handleError("curencies", error)));
        const poConfigurationsObservable = this.purchaseService.getPOConfigurations("Purchase").pipe(catchError((error) => this.handleError("configuration", error)));
        const vendorObservable = this.purchaseService.getAllPOVendors().pipe(catchError((error) => this.handleError("Vendor", error)));
        const shippingTermsObservable = this.purchaseService.getShippingTermList().pipe(catchError((error) => this.handleError("ShippingTerm", error)));
        const fobPointsObservable = this.purchaseService.getFOBList().pipe(catchError((error) => this.handleError("FOB", error)));
        const discountsObservable = this.salesOrderService.getDiscounts(false).pipe(catchError((error) => this.handleError("Discount", error)));
        const trackingOptionsObservable = this.purchaseService.loadTrackingOptions().pipe(catchError((error) => this.handleError("tracking", error)));
        const allUserObservable = this.salesOrderService.getAllUser().pipe(catchError((error) => this.handleError("All User", error)));
        const financialAccObservable = this.financeService.getAllFinancialAccounts(false).pipe(catchError((error) => this.handleError("Financial Account", error)));
        const classObservable = this.financeService.getAllClasses().pipe(catchError((error) => this.handleError("Class", error)));

        forkJoin([allUserObservable, financialAccObservable, classObservable, locationObservable, CurrenciesObservable, poConfigurationsObservable, vendorObservable, shippingTermsObservable, fobPointsObservable, discountsObservable, trackingOptionsObservable]).subscribe(
            ([allUserData, financialAccounts, allClass, locationData, CurrenciesData, poConfigurationsData, vendorData, shippingData, fobData, discountData, trackingOptionData]) => {
                const parsedConfig = JSON.parse(poConfigurationsData.filter((config) => config.name == "Purchase Template")[0]?.configurationDetails[0].configJSONValue);
                this.vendorCreditTemplate = parsedConfig?.filter((t) => t.templateName == "Vendorcredit_template")[0];
                this.trackingOptions = trackingOptionData;
                this.allShippingTerms = shippingData;
                this.allFOBPoints = fobData;
                this.allVendors = vendorData;
                this.setAdditionalDiscounts(discountData)
                this.getBaseCurrency(CurrenciesData)
                this.getAllLocations(locationData)
                this.prepareTrackingForm();
                this.salesRep = allUserData;
                this.financialAccounts = this.financeUtilityService.prepareFinancialAccountsData(financialAccounts);
                this.allClass = this.financeUtilityService.prepareHierarchicalClassData(allClass);
                this.appMainService.isHideSpinner("loadData");
                if (this.selectedVendorCreditId && this.selectedVendorCreditId > 0 && (this.dialogType == "EDIT" || this.dialogType == "COPY" || this.dialogType == "VIEW")) {
                    this.getVendorCreditById(this.selectedVendorCreditId);
                }
                this.initDataForNewVendorCredit();

            },
            (error) => {
                this.appMainService.isHideSpinner("loadData");
                this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
            },
        );
    }
    private handleError(apiName: string, error: any) {
        this.appMainService.isHideSpinner("loadData");
        this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        return of(null);
    }

    async initDataForNewVendorCredit() {
        // this.loadInitialData();
        this.appValue = this.app;
        this.allModules = this.app.preLoadedObjects;
        const obj = this.allModules.filter((obj) => obj?.name == ObjectNames.purchaseOrderConstants.purchaseFieldName)[0];
        await this.loadCustomFields(obj.id);
        this.initFormData();

        this.amountExpense = 0;
        this.amountItem = 0;
        this.discount = 0;
        this.subTotal = 0;
        this.discountRate = 0;
        this.shippingAmount = 0;
        this.expenses = [];
        this.items = [];
        this.shipAddress = null;
        this.allVendorsDD = this.allVendors?.filter((vendor) => vendor.isActive == true);
        this.activeVendorAddresses = [];
        this.vendorCreditForm.controls["vendorCreditDate"].setValue(this.app._showDateTimeWithZone(new Date()));
        this.shipAddress = this.allLocationsDD?.find((location) => location.isDefault == true);
    }



    /** Vendor Credit View */
    prepareVendorCreditViewData() {
        this.vendorCreditForm?.disable();
    }

    /** Vendor Credit edit */
    getVendorCreditById(vendorCreditId: number) {
        this.reCalculateNotEnabled = false;
        this.appMainService.isShowSpinner("loadVCreditDetails");
        this.purchaseService
            .getVendorCreditById(vendorCreditId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (vendorCredit) => {
                    this.appMainService.isHideSpinner("loadVCreditDetails");
                    this.setVendorCreditDetails(vendorCredit);
                },
                error: (error) => {
                    this.isDisabled = false;
                    this.appMainService.isHideSpinner("loadVCreditDetails");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }
    setVendorCreditDetails(vendorCredit) {
        this.vendorCreditDetails = vendorCredit;
        this.closingDate = this.app._showDateTimeWithZone(new Date(this.vendorCreditDetails?.createdDate));
        const currentYear = this.app._showDateTimeWithZone(new Date(this.vendorCreditDetails?.createdDate)).getFullYear();
        this.minDate = new Date(currentYear, 0, 1);
        this.maxDate = new Date(currentYear, 11, 31);
        this.currentPostingPeriodInfo = {
            postingDate: this.app._showDateTimeWithZone(new Date(this.vendorCreditDetails?.createdDate)),
            postingMonth: this.vendorCreditDetails?.postingMonth,
            postingYear: this.vendorCreditDetails?.postingYear,
        }
        this.shipAddress = this.allLocationsDD?.find((location) => location.id == this.vendorCreditDetails?.warehouseId);
        this.getShipAddress(this.shipAddress, true);
        this.setExpenseData();
        this.setProuctsData();
        this.setCustomFieldsData();
        this.setVendorCreditFormData();
        if (this.dialogType == "VIEW") {
            this.prepareVendorCreditViewData();
        }
    }
    setVendorCreditFormData() {
        this.vendorCreditForm.patchValue({
            ...this.vendorCreditDetails,
            vendorCreditDate: this.app._showDateTimeWithZone(new Date(this.vendorCreditDetails?.vendorCreditDate)),
            vendorId: this.allVendorsDD?.find((vendor) => vendor.id == this.vendorCreditDetails?.vendorId),
            paymentTermId: this.vendorPaymentTermsDD?.find((term) => term.paymentTermId == this.vendorCreditDetails?.paymentTerm?.id),
            paymentMethodId: this.vendorPaymentMethodsDD?.find((method) => method.paymentMethodId == this.vendorCreditDetails?.paymentMethod?.id),
            shippingTermId: this.allShippingTerms?.find((term) => term.id == this.vendorCreditDetails?.shippingTerm?.id),
            shippingMethodId: this.vendorShippingMethodsDD?.find((method) => method.id == this.vendorCreditDetails?.shippingMethod?.id),
            userId: this.salesRep?.find((user) => user.id == this.vendorCreditDetails?.user?.id),
            note: this.vendorCreditDetails?.vendorCreditNotes?.[this.vendorCreditDetails?.vendorCreditNotes?.length - 1]?.note ?? "",
            class: this.financeUtilityService.findRecursiveChildObjects(this.allClass, this.vendorCreditDetails?.class?.id),
            creditAmount: this.vendorCreditDetails?.creditAmount ? this.vendorCreditDetails?.creditAmount * this.vendorCreditDetails?.exchangeRate : 0
        });
    }
    setExpenseData() {
        this.expenses = this.vendorCreditDetails?.vendorCreditExpenses?.map((expense) => ({
            ...expense,
            className: expense?.class?.name,
            originalTotalAmount: expense?.totalAmount,
            totalAmount: expense?.totalAmount * this.vendorCreditDetails?.exchangeRate,
        })) ?? [];
        this.calculateExpense();
    }
    setProuctsData() {
        if (this.vendorCreditDetails?.discountId) {
            this.selectedValueOption = this.allDiscounts?.find((value) => value.id == this.vendorCreditDetails?.discountId);
        } else {
            this.selectedValueOption = null;
        }
        this.discountRate = this.vendorCreditDetails?.discountRate ?? 0;
        this.discount = this.vendorCreditDetails?.discountAmount ?? 0;
        this.subTotal = this.vendorCreditDetails?.itemAmount ?? 0;
        this.amountItem = this.vendorCreditDetails?.netAmount ?? 0;
        this.shippingAmount = this.vendorCreditDetails?.shippingAmount ? this.vendorCreditDetails?.shippingAmount * this.vendorCreditDetails?.exchangeRate : 0;
        const isTaxColumnVisible = this.vendorCreditTemplate?.labels_table?.[5]?.isChecked;

        this.selectedProductsList = this.vendorCreditDetails?.vendorCreditProducts?.map((product: any) => {
            const exchangeRate = this.vendorCreditDetails?.exchangeRate ? this.vendorCreditDetails?.exchangeRate : this.vendorExchangeRate;
            const totalAmount = Number(product.totalAmount);
            const taxAmount = product.vendorCreditProductSubTax?.reduce((sum, s) => sum + Number(s.taxAmount || 0), 0) ?? 0;
            const convertedTaxAmount = taxAmount * exchangeRate;
            const convertedTotalAmount = totalAmount * exchangeRate;

            return {
                id: product.id,
                itemNo: product.itemNo,
                productId: product.productId,
                description: product.description ?? "",
                uom: [{ uomDetail: { categoryId: product?.categoryId } }],
                unit: null,
                availabel: product.quantity,
                originalQty: product.totalQty,
                qoh: product.totalQty,
                typeId: product.typeId,
                originalCost: totalAmount,
                originalPrice: product.pricePerProduct,
                cost: convertedTotalAmount,
                price: product.pricePerProduct * exchangeRate,
                trackingEnabled: product.isTrackingRequired,
                serialSettings: product.serialSettings ? JSON.parse(product.serialSettings) : null,
                vendorCreditProductSerialDetails: this.dialogType == 'COPY' ? [] : product.vendorCreditProductSerialDetails ?? [],
                productUOMId: product.productUOMId,
                productSubTax: product.vendorCreditProductSubTax,
                taxAmount: convertedTaxAmount.toFixed(this.length),
                lineTotal: isTaxColumnVisible
                    ? (convertedTotalAmount + convertedTaxAmount).toFixed(this.length)
                    : convertedTotalAmount.toFixed(this.length)
            };
        });

        this.lineTotal = this.selectedProductsList.reduce((sum, s) => sum + Number(s.lineTotal), 0);
        this.lineTotal = Number(this.lineTotal) * Number(this.vendorCreditDetails?.exchangeRate);
        this.tax = Number(this.selectedProductsList?.reduce((sum, s) => sum + Number(s.taxAmount), 0)) * Number(this.vendorCreditDetails?.exchangeRate);

        this.items = this.selectedProductsList;
        this.calculateItemExpense();
    }
    setCustomFieldsData(): void {
        Object.keys(this.customAtributes).forEach((key) => {
            const dataArr = this.customAtributes[key];
            if (dataArr && dataArr.length > 0) {
                dataArr.forEach((element) => {
                    const filteredCustom = this.vendorCreditDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                    if (filteredCustom && filteredCustom.formControlName == "InputBox") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.formControlName == "Decimal") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.formControlName == "Number") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.formControlName == "DatePicker") {
                        element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                    } else if (filteredCustom && (filteredCustom.formControlName == "FileUpload" || filteredCustom.formControlName == "Picture")) {
                        element.customUploadedFiles = [];
                        filteredCustom.customeAttachement.forEach((el) => {
                            element.customUploadedFiles.push(el);
                        });
                    } else if (filteredCustom && filteredCustom.formControlName == "Rating") {
                        element.value = filteredCustom.ratingId;
                    } else if (filteredCustom && filteredCustom.formControlName == "ToggleButton") {
                        element.value = filteredCustom.toggle;
                    } else if (filteredCustom && filteredCustom.formControlName == "DropDownList") {
                        element.value = filteredCustom.values;
                    } else if (filteredCustom && filteredCustom.formControlName == "RadioButton") {
                        element.value = filteredCustom.values?.name;
                    } else if (filteredCustom && filteredCustom.formControlName == "CheckBox") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el?.name);
                        });
                    } else if (filteredCustom && filteredCustom.formControlName == "MultipleDropDownList") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el);
                        });
                    }
                });
            }
        });
    }
    /** End Vendor Credit edit */

    /** Vendor Credit save and update*/
    prepareVendorCreditProducts(): IVendorCreditProduct[] {
        return (this.items || []).map((item) => ({
            id: item.id ?? 0,
            productId: item.productId ?? 0,
            productUOMId: item?.productUOMId ?? 0,
            pricePerProduct: Number(item.price),
            quantity: item.availabel,
            totalQty: item.availabel,
            totalAmount: Number(item.cost),
            warehouseId: this.shipAddress?.id ?? 0,
            vendorCreditProductSerialDetails: this.setProductSerialDetails(item.vendorCreditProductSerialDetails),
            description: item.description ?? "",
            lineTotal: Number(item.lineTotal),
            vendorCreditProductSubTax: this.setProductSubTax(item),
        }));
    }

    prepareVendorCreditExpenses(): IVendorCreditExpense[] {
        return (this.expenses || []).map((expense) => ({
            id: expense?.id ?? 0,
            financialAccountId: expense?.financialAccountId ?? 0,
            memo: expense?.memo ?? "",
            totalAmount: expense?.totalAmount ?? 0,
            classId: expense?.class?.id ?? 0,
        }));
    }
    prepareVendorCredit(): IVendorCredit {
        
        const vendorCredit: IVendorCredit = {
            id: (this.selectedVendorCreditId == 0 || this.dialogType == "COPY") ? 0 : this.vendorCreditDetails?.id,
            vendorId: this.vendorCreditForm?.controls?.vendorId.value?.id ?? 0,
            VendorName: this.vendorCreditForm?.controls?.vendorId.value?.name ?? "",
            billingAddressId: this.vendorCreditForm?.controls?.shippingAddressId?.value ?? null,
            billingContactId: this.vendorCreditForm?.controls?.contactId?.value ?? null,
            shippingAddressId: this.vendorCreditForm?.controls?.shippingAddressId?.value ?? null,
            shippingContactId: this.vendorCreditForm?.controls?.contactId?.value ?? null,
            vendorCreditDate: this.app._saveDateTimeWithZone(this.vendorCreditForm?.controls?.vendorCreditDate?.value, false),
            expiryDate: this.app._saveDateTimeWithZone(this.vendorCreditForm?.controls?.vendorCreditDate?.value, false),
            referenceNumber: this.vendorCreditForm?.controls?.referenceNumber?.value ?? "",
            warehouseId: this.shipAddress?.id ?? 0,
            currencyUnitId: this.vendorDetails?.currencyId,
            exchangeRate: ((this.reCalculateNotEnabled ? this.previousExchangeRate : this.vendorExchangeRate) ?? 0),
            warehouseAddressId: this.shipAddress?.addressId ?? 0,
            discountId: (this.discount > 0 && this.selectedValueOption) ? this.allDiscounts?.find(discount => discount.id === this.selectedValueOption?.id)?.id : null,
            discountName: this.selectedValueOption?.type?.name ?? "",
            discountFinancialId: this.discount > 0 ? this.allDiscounts?.filter((discount) => discount.discountBy == this.selectedValueOption?.id).map((value) => value.incomeAccount)[0] : null,
            discountRate: this.discountRate ?? 0,
            discountAmount: this.discount,
            shippingAmount: Number(this.shippingAmount),
            itemAmount: this.subTotal,
            expenseAmount: this.amountExpense,
            netAmount: this.amountItem,
            creditAmount: this.vendorCreditForm?.controls?.creditAmount?.value,
            note: this.vendorCreditForm?.controls?.note?.value ?? "",
            paymentTermId: this.vendorCreditForm?.controls?.paymentTermId?.value?.paymentTermId ?? null,
            paymentMethodId: this.vendorCreditForm?.controls?.paymentMethodId?.value?.paymentMethodId ?? null,
            shippingTermId: this.vendorCreditForm?.controls?.shippingTermId?.value?.id ?? null,
            shippingMethodId: this.vendorCreditForm?.controls?.shippingMethodId?.value?.shippingMethodId ?? null,
            userId: this.vendorCreditForm?.controls?.userId?.value?.id ?? null,
            classId: this.vendorCreditForm?.controls?.class?.value?.id ?? null,
            vendorCreditExpenses: this.prepareVendorCreditExpenses(),
            vendorCreditProducts: this.prepareVendorCreditProducts(),
            vendorCreditStatusId: (this.selectedVendorCreditId == 0 || this.dialogType == "COPY") ? 1 : this.vendorCreditDetails?.vendorCreditStatusId,
            statusId: (this.selectedVendorCreditId == 0 || this.dialogType == "COPY") ? Status.Active : this.vendorCreditDetails?.statusId,
            customAttributeValues: this.prepareCustomAttributes(this.getCustomAttributesForAddEdit(this.customAtributes)),
            isConvertedFromRMA: false, 
            postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : (this.dialogType == "EDIT" ? this.vendorCreditDetails?.postingDate : this.app._saveDateTimeWithZone(this.vendorCreditForm.controls["vendorCreditDate"].value)),
            postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : (this.dialogType == "EDIT" ? this.vendorCreditDetails?.postingMonth : (new Date(this.vendorCreditForm.controls["vendorCreditDate"].value).getMonth() + 1)),
            postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : (this.dialogType == "EDIT" ? this.vendorCreditDetails?.postingYear : (new Date(this.vendorCreditForm.controls["vendorCreditDate"].value).getFullYear())),
            taxAmount: this.tax
        };
        return vendorCredit;
    }
    /** Custom fields */
    getCustomAttributesForAddEdit(customFields) {
        const customattributeList = [];
        const cf = customFields;
        Object.keys(cf).forEach((key) => {
            const dataArr = cf[key];
            if (dataArr && dataArr.length > 0) {
                dataArr?.forEach((element) => {
                    if ((element?.formControl?.name == "FileUpload" || element?.formControl?.name == "Picture") && element?.customUploadedFiles?.length > 0) {
                        customattributeList.push(element);
                    } else if (element.value) {
                        customattributeList.push(element);
                    }
                });
            }
        });
        return customattributeList;
    }

    prepareCustomAttributes(value) {
        const custom: any[] = [];
        value?.forEach((element) => {
            const customEach = {
                id: (this.selectedVendorCreditId == 0 || this.dialogType == "COPY") ? 0 : this.vendorCreditDetails.customAttributeValues.find((c) => c.customAttributeId == element.id)?.id,
                customAttributeId: (this.selectedVendorCreditId == 0 || this.dialogType == "COPY") ? element.id : this.vendorCreditDetails.customAttributeValues.find((c) => c.customAttributeId == element.id)?.customAttributeId,
                formControlId: element.formControlId,
                formControlName: element?.formControl?.name,
                value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" || element.formControl?.name == "Number" ? element.value : null,
                values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                isRequired: element.isRequired,
                statusId: (this.selectedVendorCreditId == 0 || this.dialogType == "COPY") ? Status.Active : element.statusId,
                customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
            };
            custom.push(customEach);
        });
        return custom;
    }
    // modifyCustumAttributes(data) {
    //     if (data.pickListValues) {
    //         data.pickListValues = JSON.stringify(data.pickListValues);
    //     }
    //     return data;
    // }
    setCheckBoxValue(value) {
        const checkBox: any[] = [];
        value.forEach((element) => {
            const val = { name: element };
            checkBox.push(val);
        });
        return checkBox;
    }
    onCustomUpload(files: File[], field) {
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(file, 4, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {
                        let attachment = {
                            name: name,
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                        };
                        field.customUploadedFiles.push(attachment);
                    });
                }
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
    }
    /** End Custom Fields */
    deleteVendorCredit(event) {
        this.onDeleteVendorCredit.emit({ event: false, statementMessege: this.statementMessege });
    }
    saveVendorCredit(action: string) {
        if (this.utilService.checkSerialNoValidationBill(this.items)) {
            const isValid = this.utilityService.checkvalidation(this.customAtributes);
            if (isValid) {
                const vendorCredit: IVendorCredit = this.prepareVendorCredit();
                if (this.selectedVendorCreditId == 0 || this.dialogType == "COPY") {
                    this.saveNewVendorCredit(vendorCredit, action);
                } else {
                    this.updateVendorCredit(vendorCredit);
                }
            } else {
                this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Please fill all required fields.." });
            }
        } else {
            this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Items you want to add have more serialNo added than qty.." });
            this.isDisabled = false;
        }
    }
    saveNewVendorCredit(vendorCredit: IVendorCredit, action: string) {
        this.isDisabled = true;
        const isBaseCurrency = this.baseCurrency?.currencyId == this.vendorDetails?.currencyId;
        this.appMainService.isShowSpinner("saveVCredit");
        this.purchaseService
            .saveVendorCredit(isBaseCurrency, vendorCredit)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner("saveVCredit");
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Saved Successfully ...",
                    });
                    if (action == "saveAndNew") {
                        this.isDisabled = false;
                        this.initDataForNewVendorCredit();
                    } else {
                        this.onCloseVendorCreditDialog.emit("save");
                    }
                },
                error: (error) => {
                    this.isDisabled = false;
                    this.appMainService.isHideSpinner("saveVCredit");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }
    updateVendorCredit(vendorCredit: IVendorCredit) {
        this.isDisabled = true;
        const isBaseCurrency = this.baseCurrency?.currencyId == this.vendorDetails?.currencyId;
        this.appMainService.isShowSpinner("saveVCredit");
        this.purchaseService
            .updateVendorCredit(isBaseCurrency, vendorCredit)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner("saveVCredit");
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Updated Successfully ...",
                    });
                    this.onCloseVendorCreditDialog.emit("update");
                },
                error: (error) => {
                    this.isDisabled = false;
                    this.appMainService.isHideSpinner("saveVCredit");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }
    /** End Vendor Credit save and update*/

    getSelectedVendorDetails(vendorId, refreshExchangeRate) {
        this.amountExpense = 0;
        this.amountItem = 0;
        this.discount = 0;
        this.subTotal = 0;
        this.discountRate = 0;
        this.shippingAmount = 0;
        this.expenses = [];
        this.items = [];
        this.selectedValueOption = null;
        this.activeVendorAddresses = [];
        this.shipAddress = this.allLocationsDD?.find((location) => location.isDefault);
        this.vendorCreditForm.controls["creditAmount"].setValue(null);
        this.appMainService.isShowSpinner("vendor");
        this.vendorCreditForm.controls["shippingAddressId"].setValue(null);
        this.purchaseService.getVendorById(vendorId).subscribe((value) => {
            this.vendorDetails = value;
            if (refreshExchangeRate) {
                this.updateExchangeRate()
            }
            //Active Vendor Payment Term
            this.vendorPaymentTermsDD = this.vendorDetails?.vendorPaymentTerm?.filter((term) => term.statusId == Status.Active);
            if (this.dialogType == "EDIT" || this.dialogType == "VIEW") {
                const inActivePaymentTerm = this.vendorPaymentTermsDD?.find(v => v.paymentTermId == this.vendorCreditDetails?.paymentTerm?.id);
                if (!inActivePaymentTerm && this.vendorCreditDetails?.paymentTerm) {
                    const obj = {
                        paymentTermId: this.vendorCreditDetails?.paymentTerm?.id,
                        statusId: this.vendorCreditDetails?.paymentTerm?.statusId,
                        paymentMethodTerm: this.vendorCreditDetails?.paymentTerm?.name
                    }
                    this.vendorPaymentTermsDD.push(obj);
                }
                // Payment Term which is not part of vendor (WF PO)
                const nonVendorPaymentTerm = this.vendorDetails?.vendorPaymentTerm?.find(v => v.paymentTermId == this.vendorCreditDetails?.paymentTermId);
                if (!nonVendorPaymentTerm && this.vendorCreditDetails?.paymentTerm) {
                    const obj = {
                        paymentTermId: this.vendorCreditDetails?.paymentTerm?.id,
                        statusId: this.vendorCreditDetails?.paymentTerm?.statusId,
                        paymentMethodTerm: this.vendorCreditDetails?.paymentTerm?.name
                    }
                    this.vendorPaymentTermsDD.push(obj);
                }
            }
            //Active Vendor Payment Method
            this.vendorPaymentMethodsDD = this.vendorDetails?.vendorPaymentMethod?.filter((method) => method.statusId == Status.Active);
            if (this.dialogType == "EDIT" || this.dialogType == "VIEW") {
                const inActivePaymentMethod = this.vendorPaymentMethodsDD?.find(v => v.paymentMethodId == this.vendorCreditDetails?.paymentMethodId);
                if (!inActivePaymentMethod && this.vendorCreditDetails?.paymentMethod) {
                    const obj = {
                        paymentMethodId: this.vendorCreditDetails?.paymentMethod?.id,
                        statusId: this.vendorCreditDetails?.paymentMethod?.statusId,
                        paymentMethodMethod: this.vendorCreditDetails?.paymentMethod?.name
                    }
                    this.vendorPaymentMethodsDD.push(obj);
                }
                // Payment Method which is not part of vendor (WF PO)
                const nonVendorPaymentMethod = this.vendorDetails?.vendorPaymentMethod?.find(v => v.paymentMethodId == this.vendorCreditDetails?.paymentMethodId);
                if (!nonVendorPaymentMethod && this.vendorCreditDetails?.paymentMethod) {
                    const obj = {
                        paymentMethodId: this.vendorCreditDetails?.paymentMethod?.id,
                        statusId: this.vendorCreditDetails?.paymentMethod?.statusId,    
                        paymentMethodMethod: this.vendorCreditDetails?.paymentMethod?.name  
                    }
                    this.vendorPaymentMethodsDD.push(obj);
                }
            }
            //Active Vendor Shipping Method
            this.vendorShippingMethodsDD = this.vendorDetails?.vendorShippingMethod?.filter((shipping) => shipping.statusId == Status.Active);
            if (this.dialogType == "EDIT" || this.dialogType == "VIEW") {
                const inActiveShippingMethod = this.vendorShippingMethodsDD?.find(v => v.shippingMethodId == this.vendorCreditDetails?.shippingMethodId);
                if (!inActiveShippingMethod && this.vendorCreditDetails?.shippingMethod) {
                    const obj = {
                        shippingMethodId: this.vendorCreditDetails?.shippingMethod?.id,
                        statusId: this.vendorCreditDetails?.shippingMethod?.statusId,
                        shippingMethodMethod: this.vendorCreditDetails?.shippingMethod?.name
                    }
                    this.vendorShippingMethodsDD.push(obj);
                }
                // Shipping Method which is not part of vendor (WF PO)
                const nonVendorShippingMethod = this.vendorDetails?.vendorShippingMethod?.find(v => v.shippingMethodId == this.vendorCreditDetails?.shippingMethodId);
                if (!nonVendorShippingMethod && this.vendorCreditDetails?.shippingMethod) {
                    const obj = {
                        shippingMethodId: this.vendorCreditDetails?.shippingMethod?.id,
                        statusId: this.vendorCreditDetails?.shippingMethod?.statusId,   
                        shippingMethodMethod: this.vendorCreditDetails?.shippingMethod?.name    
                    }
                    this.vendorShippingMethodsDD.push(obj);
                }
            }
            this.appMainService.isHideSpinner("vendor");
            this.shipAddress = this.allLocationsDD?.find((location) => location.isDefault);
            this.getShipAddress(this.shipAddress, true);
            this.onChangeVendor(value, 'view');
        });
    }
    
    showEditExchangeRate(event) {
        this.overlayPanel.toggle(event);
        this.reCalculateNotEnabled = false;
    }

    closeCurrencyDialog(value) {
        if (!value.formData) return;
        const { defaultRateEnabled, enableRecalculateItemRate, exchangeRate } = value.formData;
        if (!defaultRateEnabled && enableRecalculateItemRate) {
            this.updateExchangeRate(exchangeRate);
            this.reCalculatePrices(value);
        } else if (defaultRateEnabled) {
            this.updateExchangeRate(exchangeRate);
            if (enableRecalculateItemRate) {
                this.reCalculatePrices(value);
            } else {
                this.reCalculateNotEnabled = true;
                this.previousExchangeRate = value.previousExchangeRate;
            }
        }
        this.overlayPanel.hide();
    }

    updateExchangeRate(exchangeRate?) {
        const newExchangeRate = exchangeRate ?? this.orgCurrency?.find((cr) => cr.currencyId === this.vendorDetails?.currencyId)?.exchangeRate;
        if (this.dialogType === "CREATE") {
            const vendorCurrency = this.orgCurrency?.find((cr) => cr.currencyId === this.vendorDetails?.currencyId);
            if (vendorCurrency) {
                vendorCurrency.exchangeRate = newExchangeRate;
            }
        } else {
            this.vendorCreditDetails.exchangeRate = newExchangeRate;
        }
    }
    get vendorExchangeRate() {
        if (this.dialogType == "CREATE") {
            return this.orgCurrency?.find((cr) => cr.currencyId == this.vendorDetails?.currencyId)?.exchangeRate;
        } else {
            return this.vendorCreditDetails?.exchangeRate;
        }
    }
    onChangeVendor(value, action?: string) {
        //Set Payment Term
        this.vendorCreditForm.controls["paymentTermId"].setValue(value.vendorPaymentTerm?.filter((term) => term.isDefault == true)[0]);
        if (this.vendorCreditForm.controls["paymentTermId"].value) {
            const dueDate = this.utilService.getDueDate(this.vendorCreditForm.controls["paymentTermId"].value?.paymentTerm, new Date());
            if (dueDate) {
                const normalDate = this.app._showDateTimeWithZone(new Date(dueDate));
                this.vendorCreditForm.controls["dueDate"].setValue(normalDate);
            } else {
                const date = this.app._showDateTimeWithZone(new Date());
                this.vendorCreditForm.controls["dueDate"].setValue(date);
            }
        } else {
            const date = this.app._showDateTimeWithZone(new Date());
            this.vendorCreditForm.controls["dueDate"].setValue(date);
        }
        //Set Payment Method
        this.vendorCreditForm.controls["paymentMethodId"].setValue(value.vendorPaymentMethod?.filter((method) => method.isDefault == true)[0]);
        //Set Shippong Method
        this.vendorCreditForm.controls["shippingMethodId"].setValue(value.vendorShippingMethod?.filter((method) => method.isDefault == true)[0]);
        this.activeVendorAddresses = value.vendorAddresses?.filter((add) => add.statusId == Status.Active); //Active Address

        if (this.activeVendorAddresses.length == 1) {
            this.vendorCreditForm.controls["shippingAddressId"].setValue(this.activeVendorAddresses[0]?.addressId);
            this.ordersVendorAddrNew = this.activeVendorAddresses[0]?.address?.streetAddress1 == "" ? this.activeVendorAddresses[0]?.address?.streetAddress2 : this.activeVendorAddresses[0]?.address?.streetAddress1 + "," + this.activeVendorAddresses[0]?.address?.streetAddress2;
            this.ordersVendorCityNew = this.activeVendorAddresses[0]?.address?.city?.name ?? "";
            this.ordersVendorStateNew = this.activeVendorAddresses[0]?.address?.state?.name ?? "";
            this.ordersVendorCountryNew = this.activeVendorAddresses[0]?.address?.country?.name ?? "";
            this.ordersVendorZipcodeNew = this.activeVendorAddresses[0]?.address?.zipCode;
            if (this.activeVendorAddresses[0]?.address.attnContactId) {
                for (let vendorContact of value.vendorContacts) {
                    if (vendorContact.contactId == this.activeVendorAddresses[0]?.address.attnContactId) {
                        this.vendorCreditForm.controls["contactId"].setValue(vendorContact.contactId);
                        this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
                        this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    }
                }
            } else {
                for (let vendorContact of value.vendorContacts) {
                    if (vendorContact.contact?.isPrimaryContact) {
                        this.vendorCreditForm.controls["contactId"].setValue(vendorContact.contactId);
                        this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
                        this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    }
                }
            }
        } else if (this.activeVendorAddresses.length > 1) {
            this.selectedVendorDD = value;
            this.selectedVendorDD.vendorAddresses = value.vendorAddresses?.filter((add) => add.statusId == 1); //Active Address
            this.selectedVendorAddress = null;
            if (action != 'view') {
                this.displayVendorAddress = true;
            }
        } else {
            this.ordersVendorAddrNew = "";
            this.ordersVendorCityNew = "";
            this.ordersVendorStateNew = "";
            this.ordersVendorCountryNew = "";
            this.ordersVendorZipcodeNew = "";
            this.ordersVendorPhoneNew = "";
            this.ordersVendorContactNew = "";
            for (let vendorContact of value.vendorContacts) {
                if (vendorContact.contact?.isPrimaryContact) {
                    this.vendorCreditForm.controls["contactId"].setValue(vendorContact.contactId);
                    this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                }
            }
        }
    }

    async getShipAddress(location, action?) {
        this.shipAddress = location;
        await this.getTaxByAddress(this.shipAddress?.address?.countryId);
        if (!action) {
            this.panel.hide();
        }
    }

    changeVendorContact() {
        this.selectedVendorContact = null;
        this.selectedVendorContact = this.vendorDetails?.vendorContacts?.filter((contact) => contact.contactId == this.vendorCreditForm.controls["contactId"].value)[0];
        this.displayVendorContact = true;
    }

    onRowSelectContact() {
        this.vendorCreditForm.controls["contactId"].setValue(this.selectedVendorContact.contactId);
        this.ordersVendorPhoneNew = this.selectedVendorContact.contact?.contactPhones[0]?.phone?.number;
        this.ordersVendorContactNew = this.selectedVendorContact.contact?.firstName + " " + this.selectedVendorContact.contact?.lastName;
        this.displayVendorContact = false;
    }

    onRowSelectAddress(value) {
        this.displayVendorAddress = false;
        this.vendorCreditForm.controls["shippingAddressId"].setValue(this.selectedVendorAddress?.addressId);
        this.ordersVendorAddrNew = this.selectedVendorAddress?.address?.streetAddress1 == "" ? this.selectedVendorAddress?.address?.streetAddress2 : this.selectedVendorAddress?.address?.streetAddress1 + " " + this.selectedVendorAddress?.address?.streetAddress2;
        this.ordersVendorCityNew = this.selectedVendorAddress?.address?.city?.name ?? "";
        this.ordersVendorStateNew = this.selectedVendorAddress?.address?.state?.name ?? "";
        this.ordersVendorCountryNew = this.selectedVendorAddress?.address?.country?.name ?? "";
        this.ordersVendorZipcodeNew = this.selectedVendorAddress?.address?.zipCode;
        if (this.selectedVendorAddress?.address.attnContactId) {
            for (let vendorContact of this.vendorDetails?.vendorContacts) {
                if (vendorContact.contactId == this.selectedVendorAddress?.address.attnContactId) {
                    this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    this.vendorCreditForm.controls["contactId"].setValue(vendorContact.contactId);
                }
            }
        } else {
            for (let vendorContact of this.vendorDetails?.vendorContacts) {
                if (vendorContact.contact?.isPrimaryContact) {
                    this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    this.vendorCreditForm.controls["contactId"].setValue(vendorContact.contactId);
                }
            }
        }
    }

    /** Expense add/Edit */
    addExpense() {
        this.expenseHeader = "Add Expense";
        this.prepareExpenseForm();
        this.addExpenseFlag = true;
        this.displayAddExpense = true;
    }
    editExpense(expense) {
        this.expenseHeader = "Edit Expense";
        this.addExpenseFlag = false;
        this.prepareExpenseForm();
        this.accountForm.patchValue({
            ...expense,
            financialAccountId: this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, expense?.financialAccountId),
            class: this.financeUtilityService.findRecursiveChildObjects(this.allClass, expense?.class?.id),
        });
        this.displayAddExpense = true;
    }
    saveExpense(value) {
        if (value.totalAmount == 0) {
            this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Amount must be greater than 0..." });
            return;
        }
        const expense = {
            ...value,
            financialAccountId: value?.financialAccountId?.value?.id ?? 0,
            financialAccountName: value?.financialAccountId?.value?.name ?? "",
            className: value?.class?.name ?? "",
        };
        if (this.addExpenseFlag) {
            this.expenses.push(expense);
        } else {
            const index = this.expenses?.findIndex((exp) => exp.id == value.id);
            this.expenses[index] = expense;
        }
        this.calculateExpense();
        this.displayAddExpense = false;
    }
    calculateExpense() {
        this.amountExpense = 0;
        for (let exp of this.expenses) {
            this.amountExpense = this.amountExpense + exp.totalAmount;
        }
        const amoutDue = Number(this.amountExpense) + Number(this.amountItem);
        this.vendorCreditForm.controls["creditAmount"].setValue(amoutDue);
    }
    /** End Expense add/Edit */

    /** Product add/edit */
    onGlobalSearch() {
        this.pageNumber = 1;
        this.searchValue = this.productGlobalFilterInput;
        const vendorId = this.vendorCreditForm.controls["vendorId"].value?.id;
        this.getAllProducts(this.selectedTBChannel.id, this.pageNumber, this.pageSize, vendorId, this.searchValue);
    }

    getProductsChannels(name) {
        this.productsService.getAllProductChannel(name).subscribe((channels) => {
            const config = JSON.parse(channels.configurationDetails[0].configJSONValue);
            this.productChannels = config.filter((el) => !["Kit/Package Items", "Bundle Item"].includes(el?.name));
            this.selectedTBChannel = this.productChannels?.find((ch) => ch.isDefault);
        });
    }

    changeTBChannel() {
        this.productGlobalFilterInput = "";
        this.pageNumber = 1;
        const vendorId = this.vendorCreditForm.controls["vendorId"].value?.id;
        this.getAllProducts(this.selectedTBChannel.id, this.pageNumber, this.pageSize, vendorId, "");
    }
    getTBData(event) {
        this.pageNumber = event.first / event.rows + 1;
        this.pageSize = event.rows;
        this.first = event.first;
        const vendorId = this.vendorCreditForm.controls["vendorId"].value?.id;
        this.getAllProducts(this.selectedTBChannel.id, this.pageNumber, this.pageSize, vendorId, this.searchValue);
    }

    openProducts(type?, bundle?) {
        if (type) {
            this.isBundle = true;
            this.selectedBundle = bundle;
        }
        this.selectedProductsList = this.items;
        this.first = 0;
        const vendorId = this.vendorCreditForm.controls["vendorId"].value?.id;
        this.pageNumber = 1;
        this.selectedTBChannel = this.productChannels?.find((ch) => ch.isDefault);
        this.getAllProducts(this.selectedTBChannel.id, this.pageNumber, this.pageSize, vendorId, "");
    }

    addProduct() {
        for (let prd of this.selectedProductsList) {
            const alreadyExist = this.items?.find((d) => d.id == prd.id);
            if (!alreadyExist) {
                prd.productSubTax = [];
                prd.taxAmount = Number(0);
                if (!prd.originalPrice) {
                    prd.originalPrice = prd.price;
                }
                if (!prd.originalCost) {
                    prd.originalCost = prd.cost;
                }
                prd.price = prd.originalPrice * this.vendorExchangeRate;
                prd.cost = prd.originalCost * this.vendorExchangeRate;
                prd.lineTotal = prd.originalPrice * this.vendorExchangeRate;
                prd.id = 0;
                this.items.push({ ...prd });
            }
        }
        //remove deselected items from list
        const unmatched = this.items?.filter((item) => !this.selectedProductsList?.some((_item) => _item.id === item.id));
        for (let prd of unmatched) {
            const index = this.items?.indexOf(prd);
            this.items?.splice(index, 1);
        }
        this.calculateItemExpense();
        this.displayProductsTb = false;
    }
    reCalculatePrices(value) {
        this.items = this.items.map(prd => ({
            ...prd,
            originalPrice: prd.originalPrice || prd.price,
            originalCost: prd.originalCost || prd.cost,
            price: Number(prd.originalPrice || prd.price) * Number(value.formData.exchangeRate),
            cost: Number(prd.originalCost || prd.cost) * Number(value.formData.exchangeRate),
        }));
        this.calculateItemExpense();
    }

    getAllProducts(typeId, pageNumber, pageSize, vendorId, searchValue) {
        this.purchaseService
            .getAllProductsBySearch(typeId, pageNumber, pageSize, vendorId, searchValue)
            .then((products) => {
                let { inventory, headers } = products;
                inventory = inventory?? [];
                headers = headers  ?? [];
                this.totalTBRecord = headers["TotalCount"];
                this.allProducts = inventory;
                this.allProductsData2 = [];
                this.productsData2 = [];
                this.prepareProductsList(inventory);
            })
            .finally(() => {
                this.noCaseFindOrLoadingText = "No Products found.";
            });
    }
    prepareProductsList(inventory) {
        if (inventory.length > 0) {
            if (this.selectedTBChannel?.name == "Inventory Item") {
                this.allProductsData2 = inventory.map((l: any) => ({
                    id: l.id,
                    itemNo: l.itemNo,
                    productId: l.id,
                    description: l.description,
                    uom: l.productUOM,
                    unit: l.productUOM[0],
                    availabel: 1,
                    originalQty: 1,
                    qoh: l.productCount?.totalQty,
                    typeId: l.typeId,
                    cost: l?.warehouseProduct?.length > 0 ? l?.warehouseProduct[0]?.buyPrice : l?.productPrice?.buyPrice,
                    lineTotal: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                                    (parseFloat(l.productPrice?.buyPrice).toFixed(this.length))),
                    price: l?.warehouseProduct?.length > 0 ? l?.warehouseProduct[0]?.buyPrice : l?.productPrice?.buyPrice,
                    trackingEnabled: l.isTrackingRequired,
                    isTrackingRequired: l.isTrackingRequired ? 'Yes' : 'No',
                    serialSettings: l.serialSettings ? JSON.parse(l.serialSettings) : null,
                    vendorCreditProductSerialDetails: [],
                    productUOMId: l?.productUOM?.[0]?.unitOfMeasureId ?? 0,
                }));
                this.productsData2 = this.allProductsData2;
                this.productsTB = this.productsData2;
                this.productsTBCol = data.bundle_product_table_column;
            } else if (this.selectedTBChannel?.name == "Service") {
                this.allServiceData2 = inventory.map((l: any) => ({
                    id: l.id,
                    productId: l.id,
                    itemNo: l.itemNo,
                    availabel: 1,
                    originalQty: 1,
                    qoh: l.availableQty,
                    description: l.description,
                    uom: l.productUOM,
                    unit: l.productUOM[0],
                    cost: l?.warehouseProduct?.length > 0 ? l?.warehouseProduct[0]?.buyPrice : l?.productPrice?.buyPrice,
                    price: l?.warehouseProduct?.length > 0 ? l?.warehouseProduct[0]?.buyPrice : l?.productPrice?.buyPrice,
                    typeId: l.typeId,
                    trackingEnabled: false,
                    serialSettings: l.serialSettings ? JSON.parse(l.serialSettings) : null,
                    productUOMId: l?.productUOM?.[0]?.unitOfMeasureId ?? 0,
                }));
                this.serviceData2 = this.allServiceData2;
                this.productsTB = this.serviceData2;
                this.productsTBCol = data.bundle_product_table_column;
            } else if (this.selectedTBChannel?.name == "Non Inventory Item") {
                this.allNonInventoryData2 = inventory.map((l: any) => ({
                    id: l.id,
                    productId: l.id,
                    itemNo: l.itemNo,
                    availabel: 1,
                    originalQty: 1,
                    qoh: l.availableQty,
                    uom: l.productUOM,
                    unit: l.productUOM[0],
                    description: l.description,
                    cost: l?.warehouseProduct?.length > 0 ? l?.warehouseProduct[0]?.buyPrice : l?.productPrice?.buyPrice,
                    lineTotal: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                                    parseFloat(l.productPrice?.buyPrice).toFixed(this.length)),
                    price: l?.warehouseProduct?.length > 0 ? l?.warehouseProduct[0]?.buyPrice : l?.productPrice?.buyPrice,
                    typeId: l.typeId,
                    trackingEnabled: false,
                    serialSettings: l.serialSettings ? JSON.parse(l.serialSettings) : null,
                    productUOMId: l?.productUOM?.[0]?.unitOfMeasureId ?? 0,
                }));
                this.nonInventoryData2 = this.allNonInventoryData2;
                this.productsTB = this.nonInventoryData2;
                this.productsTBCol = data.non_Inv_product_table_column;
            }
            this.displayProductsTb = true;
        } else {
            this.noCaseFindOrLoadingText = "No Products found.";
            this.bundleData2 = [];
            this.productsData2 = [];
            this.serviceData2 = [];
            this.nonInventoryData2 = [];
            this.productsTB = [];
        }
    }

    calculateItemExpense() {
        this.amountItem = 0;
        this.subTotal = 0;
        this.items?.forEach((item) => {
            this.subTotal = this.subTotal + Number(item.cost);
        });
        this.amountItem = this.subTotal + this.shippingAmount - this.discount;
        this.findsum();
    }
    findsum(addDiscount?) {
        this.discount = 0;
        this.subTotal = 0;
        this.lineTotal = 0;
        for (let s of this.items) {
            this.lineTotal = Number(this.lineTotal) + Number(s.lineTotal);
            this.subTotal = Number(this.subTotal) + Number(s.lineTotal); 
        }
        if (addDiscount === false) {
            this.discountRate = this.selectedValueOption?.discountValue || 0;
        }
        if (this.selectedValueOption?.type?.name == "%" || this.selectedValueOption?.type?.name == "Percentage") {
            this.discount = this.discount + Number(this.subTotal * (Number(this.discountRate) / 100));
        } else if (this.selectedValueOption?.type?.name == "$" || this.selectedValueOption?.type?.name == "Amount") {
            this.discount = this.discountRate;
        }  
         this.tax = 0;
        if(this.vendorCreditTemplate && this.vendorCreditTemplate.labels_table  && !this.vendorCreditTemplate.labels_table[5]?.isChecked){
          this.tax = this.items?.reduce((sum, s) => sum + Number(s.taxAmount), 0) ?? 0;
        }
        this.amountItem = Number(this.subTotal + (this.subTotal > 0 ? Number(this.shippingAmount) : 0) + (!this.vendorCreditTemplate.labels_table[5]?.isChecked ? this.tax : 0) - this.discount);
        const amoutDue = Number(this.amountExpense) + Number(this.amountItem);
        this.vendorCreditForm.controls["creditAmount"].setValue(amoutDue);
    }
    removeItem(index, type) {
        if (type == "item") {
            this.items.splice(index, 1);
            this.calculateItemExpense();
        } else {
            this.expenses.splice(index, 1);
            this.calculateExpense();
        }
    }
    onTableChanged(event) {
        this.getAllProducts(this.selectedTBChannel.id, this.pageNumber, this.pageSize, this.vendorCreditForm.controls["vendorId"].value?.id, this.productGlobalFilterInput);
    }

    isClosingStatementDate(event: string) {
        this.statementMessege = event;
    }

    setProductSerialDetails(serialDetails) {
        const tracking = [];
        serialDetails?.forEach((element) => {
            const trackEach = {
                id: 0,
                barcode: element.barcode,
                serialNumber2: element.serialNumber2,
                serialNumber3: element.serialNumber3,
                serialNumber4: element.serialNumber4,
                serialNumber5: element.serialNumber5,
                serialNumber6: element.serialNumber6,
                serialNumber7: element.serialNumber7,
                serialNumber8: element.serialNumber8,
                serialNumber9: element.serialNumber9,
                serialNumber10: element.serialNumber10,
                serialNumber11: element.serialNumber11,
                serialNumber12: element.serialNumber12,
                serialNumber13: element.serialNumber13,
                serialNumber14: element.serialNumber14,
                serialNumber15: element.serialNumber15,
                serialNumber16: element.serialNumber16,
                serialNumber17: element.serialNumber17,
                lotNumber: element.lotNumber,
                revisionNumber: element.revisionNumber,
                expirationDate: this.app._saveDateTimeWithZone(element.expirationDate),
                statusId: 1,
                shipped: true
            };
            tracking.push(trackEach);
        });
        return tracking;
    }

    setBundleSerialDetails(trackings) {
        const tracking = [];
        trackings.forEach((element) => {
            const trackEach = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.userId,
                updatedBy: this.app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                billOrderProductId: element.billOrderProductId,
                billOrderBundleDetailId: element.billOrderBundleDetailId,
                barcode: element.barcode,
                lotNumber: element.lotNumber,
                revisionNumber: element.revisionNumber,
                expirationDate: this.app._saveDateTimeWithZone(element.expirationDate),
                statusId: 1,
            };
            tracking.push(trackEach);
        });
        return tracking;
    }

    calculateSubTotal(item, qty, price) {
        if (item.typeId != 4) {
            item.cost = price * qty * (item.unit?.uomDetail?.value ?? 1);
            let productsTotalTax = 0;
            item?.productSubTax?.forEach((sTax) => {
                productsTotalTax += this.utilService.calculateProductsTax(sTax.taxRate, item.cost);
            });
            item.taxAmount = productsTotalTax ;
            item.lineTotal = (price * qty * (item.unit?.uomDetail?.value ?? 1)) +(this.vendorCreditTemplate && this.vendorCreditTemplate.labels_table  && this.vendorCreditTemplate.labels_table[5]?.isChecked ?  item.taxAmount : 0);
        }
        this.subTotal = 0;
        this.lineTotal = 0;
        if (item.typeId == 4) {
            item.cost = 0;
            for (let prd of item.products) {
                if (this.dialogType == 'CREATE') {
                    prd.availabel = prd.originalQty * item.availabel * (item.unit?.uomDetail?.value ?? 1)
                } else {
                    prd.availabel = item.availabel * (item.unit?.uomDetail?.value ?? 1)
                }
                prd.cost = prd.availabel * prd.price * (item.unit?.uomDetail?.value ?? 1)
                item.cost = Number(item.cost) + Number(prd.cost);
            }
        }
        this.calculateItemExpense();
    }
 
    setProductSubTax(product) {
        return product.productSubTax.map(tax => {
            tax.country = tax.country ?? this.allTaxRates?.find(t => t.id == tax.taxId)?.country;
            const baseTaxAmount = this.utilService.calculateProductsTax(tax.taxRate, product.price);
            const isIndia = tax.country === 'India';
            const isSameState = this.checkSameState();
            const halfTax = (isIndia && isSameState) ? (product.availabel * baseTaxAmount) / 2 : 0;
           
            return {
                vendorCreditProductId: product.purchaseOrderProductId ?? 0,
                taxId: tax.taxId,
                taxRate: tax.taxRate,
                taxAmount: product.availabel * baseTaxAmount,
                cgst: halfTax,
                igst: (isIndia && !isSameState) ? product.availabel * baseTaxAmount : 0,
                sgst: halfTax,
                statusId: Status.Active,
                taxFinancialId: tax.financialAccountId,
                taxName: tax.name,
                id: this.getTaxId(tax, product.productId),
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.userId,
                updatedBy: this.app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString()
            };
        });
    }
    calculateBundlePrice(bundle, item) {
        item.cost = Number(item.price * item.availabel);
        bundle.cost = 0;
        for (let prd of bundle.products) {
            bundle.cost = Number(bundle.cost) + Number(prd.cost);
        }
        this.calculateItemExpense();
    }

    get isFormIncomplete(): boolean {
        return Object.keys(this.trackingForm.controls).some(key => {
            if (key === 'serialNo') return false;
            const control = this.trackingForm.get(key);
            const isRequired = control?.validator?.({} as AbstractControl)?.['required'];
            const isEmpty = !control?.value || control.value.toString().trim() === '';
            return isRequired && isEmpty;
        });
    }

    openScanInfo(product, bundle?) {
        if (this.shipAddress) {
            this.selectedProductForScan = product;
            //this.selectedProductForScan.id = 0;
            this.isPrefix = false;
            this.isAutoGenerated = false;
            this.prefixValue = "";
            this.refId = '';
            this.totalTBRecord = 0;
            this.savedOptionSelection = product.serialSettings;
            this.prepareTrackingForm();
            this.displayScanInfo = true;
            let data;
            if (bundle) {
                this.selectedBundle = bundle;
                this.savedOptionSelection = product.serialSettings;
                data = product.billOrderBundleSerialDetail && product.billOrderBundleSerialDetail.length > 0 ? product.billOrderBundleSerialDetail[0] : null;
            } else {
                data = product.vendorCreditProductSerialDetails && product.vendorCreditProductSerialDetails.length > 0 ? product.vendorCreditProductSerialDetails[0] : null;
            }

            this.trackingForm.patchValue({
                lotNo: data?.lotNumber,
                revisionNo: data?.revisionNumber,
                expiration: data?.expirationDate ? this.app._showDateTimeWithZone(data.expirationDate) : null,
            });

            const arr: any[] = [];
            if (bundle) {
                product.billOrderBundleSerialDetail?.forEach((element) => {
                    const obj = {
                        id: element.id,
                        serialNo: element.barcode,
                        lotNo: element.lotNumber,
                        revisionNo: element.revisionNumber,
                        expiration: this.app._showDateTimeWithZone(element.expirationDate),
                    };
                    arr.push(obj);
                });
            } else {
                product.vendorCreditProductSerialDetails?.forEach((element) => {
                    const obj = {
                        id: element.id,
                        serialNo: element.barcode,
                        serialNo2: element.serialNumber2,
                        serialNo3: element.serialNumber3,
                        serialNo4: element.serialNumber4,
                        serialNo5: element.serialNumber5,
                        serialNo6: element.serialNumber6,
                        serialNo7: element.serialNumber7,
                        serialNo8: element.serialNumber8,
                        serialNo9: element.serialNumber9,
                        serialNo10: element.serialNumber10,
                        serialNo11: element.serialNumber11,
                        serialNo12: element.serialNumber12,
                        serialNo13: element.serialNumber13,
                        serialNo14: element.serialNumber14,
                        serialNo15: element.serialNumber15,
                        serialNo16: element.serialNumber16,
                        serialNo17: element.serialNumber17,
                        lotNo: element.lotNumber,
                        revisionNo: element.revisionNumber,
                        expiration: element.expirationDate ? this.app._showDateTimeWithZone(element.expirationDate) : null,
                    };
                    arr.push(obj);
                });
            }
            this.autoGenerateLists = arr;
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.listLength = this.autoGenerateLists.length;
            this.trackingForm.controls['qty'].setValue(this.selectedProductForScan.availabel - this.listLength);
            this.totalTBRecord = this.listLength;
            this.checkSerialNoInSystem(bundle ? this.selectedProductForScan?.subProductId : this.selectedProductForScan?.productId, this.shipAddress?.id);
        } else {
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Please select shipping first.",
            });
        }

        // Apply the custom validator after initializing the form
        if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
            this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator([
                'lotNo', 'revisionNo', 'expiration',
                'serialNo', 'serialNo2', 'serialNo3', 'serialNo4', 'serialNo5',
                'serialNo6', 'serialNo7', 'serialNo8', 'serialNo9', 'serialNo10',
                'serialNo11', 'serialNo12', 'serialNo13', 'serialNo14', 'serialNo15',
                'serialNo16', 'serialNo17'
            ]));
            this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
        }
    }

    applyDynamicValidation() {
        // Reset validation first
        this.trackingForm.controls['lotNo'].clearValidators();
        this.trackingForm.controls['revisionNo'].clearValidators();
        if (this.savedOptionSelection) {
            const { lotChecked, revisionChecked } = this.savedOptionSelection;

            if (lotChecked && revisionChecked) {
                // Both enabled → Apply validation to LotNo only
                this.trackingForm.controls['lotNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
            } else if (revisionChecked) {
                // Only RevisionNo enabled → Apply validation to RevisionNo
                this.trackingForm.controls['revisionNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
            } else if (lotChecked) {
                // Only LotNo enabled → Apply validation to LotNo
                this.trackingForm.controls['lotNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
            }
            // Ensure form controls update their validation state
            this.trackingForm.controls['lotNo'].updateValueAndValidity();
            this.trackingForm.controls['revisionNo'].updateValueAndValidity();
        }

        // Update the form controls
        this.trackingForm.controls['lotNo'].updateValueAndValidity();
        this.trackingForm.controls['revisionNo'].updateValueAndValidity();
    }


    /**tracking SerialNo**/
    prepareTrackingForm() {
        const qty = this.selectedProductForScan?.availabel;
        this.trackingForm = this.fb.group({
            qty: [(qty - this.listLength), [Validators.required]],
            lotNo: [""],
            revisionNo: [""],
            expiration: [""],
            serialNo: [""],
            serialNo2: [""],
            serialNo3: [""],
            serialNo4: [""],
            serialNo5: [""],
            serialNo6: [""],
            serialNo7: [""],
            serialNo8: [""],
            serialNo9: [""],
            serialNo10: [""],
            serialNo11: [""],
            serialNo12: [""],
            serialNo13: [""],
            serialNo14: [""],
            serialNo15: [""],
            serialNo16: [""],
            serialNo17: [""],
            packageBarcode: [""],
        });
        /**set validation for Tracking form**/
        if (this.trackingOptions && this.trackingOptions.length > 0) {
            for (let opt of this.trackingOptions) {
                if (opt.enabled && (this.savedOptionSelection ? this.savedOptionSelection[`${opt.code}`] : true)) {
                    if (opt.field !== "serialNo" && opt.isRequired) {
                        this.trackingForm.get(`${opt.field}`).setValidators(Validators.required);
                    } else if (opt.field === "serialNo" && opt.isRequired) {
                        if (this.utilService.displayName("serializedChecked", this.trackingOptions, "control") == "InputBox") {
                            this.trackingForm.get(`${opt.field}`).setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9-]*$/)]);
                        } else {
                            this.trackingForm.get(`${opt.field}`).setValidators([Validators.required]);
                        }
                    } else {
                        this.trackingForm.get(`${opt.field}`).clearValidators();
                    }
                    this.trackingForm.get(`${opt.field}`).updateValueAndValidity();
                }
            }
        }
    }

    countNameList(value) {
        if (this.trackingForm.valid && this.listLength < this.selectedProductForScan?.availabel) {
            if (value.serialNo) {
                value.serialNo = this.isPrefix ? this.prefixValue.concat(value.serialNo) : value.serialNo;
                const duplicate = this.autoGenerateLists?.filter((sr) => sr.serialNo == value.serialNo);
                // const present = this.systemTrackingData?.find((sr) => sr.serialNo == value.serialNo);
                for (let prd of this.items) {
                    const prdDuplicate = prd.vendorCreditProductSerialDetails?.filter((sNo) => sNo.barcode == value.serialNo);
                    if (prdDuplicate?.length > 0) {
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Duplicate serialNo found.",
                        });
                        return;
                    }
                    if (prd.products?.length > 0) {
                        for (let bundle of prd.products) {
                            const bundleDuplicate = bundle.billOrderBundleSerialDetail?.filter((sNo) => sNo.barcode == value.serialNo);
                            if (bundleDuplicate?.length > 0) {
                                this.messageService.add({
                                    severity: Severity.Error,
                                    summary: this.titlecasePipe.transform(Severity.Error),
                                    detail: "Duplicate serialNo found.",
                                });
                                return;
                            }
                        }
                    }
                }
                if (duplicate?.length > 0) {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Serial No you tried to enter is already present in below list.",
                    });
                }
                // else if (present) {
                //     this.messageService.add({
                //         severity: Severity.Error,
                //         summary: this.titlecasePipe.transform(Severity.Error),
                //         detail: "Serial No you tried to enter is already present for this product.",
                //     });
                // } 
                else {
                    this.checkSerialsForSystem(value.serialNo, this.selectedProductForScan?.id, this.shipAddress?.id, value);
                }
            } else if (!value.serialNo) {
                const totalQty = this.selectedProductForScan?.availabel;
                for (let i = 0; i < (value.qty); i++) {
                    if (this.listLength < totalQty) {
                        this.autoGenerateLists.push({ ...value });
                        this.listLength++;
                    }
                }
                this.nameLists = this.autoGenerateLists.slice(0, 100);
                this.totalTBRecord = this.listLength;
                this.trackingForm.controls['qty'].setValue(totalQty - this.listLength);
            }
        }
        const controlNames = Object.keys(this.trackingForm.controls);
        for (let ctrl of controlNames) {
            if (this.trackingOptions?.find((el) => el.field === ctrl)?.clearField) {
                this.trackingForm.controls[`${ctrl}`].setValue("");
            }
        }
    }

    checkSerialsForSystem(serialNo, productId, warehouseId, value) {
        if (this.dialogType == "EDIT" || this.dialogType == "COPY" || this.dialogType == "VIEW") {
            this.purchaseService
                .checkSerialNoInAllSystemByVendorCreditId(serialNo, warehouseId, productId, this.selectedVendorCreditId)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe((res) => {
                    if (res.allowSave) {
                        this.autoGenerateLists.push(value);
                        this.nameLists = this.autoGenerateLists.slice(0, 100);
                        this.listLength = this.listLength + 1;
                        this.totalTBRecord = this.listLength;
                        const qty = this.selectedProductForScan.availabel;
                        this.trackingForm.controls['qty'].setValue(qty - this.listLength)
                    } else {
                        this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is already associated with other product,you can't add." });
                    }
                });
        } else {
            this.purchaseService
                .checkSerialNoInAllSystemForVendorCredit(serialNo, warehouseId, productId)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe((res) => {
                    if (res.allowSave) {
                        this.autoGenerateLists.push(value);
                        this.nameLists = this.autoGenerateLists.slice(0, 100);
                        this.listLength = this.listLength + 1;
                        this.totalTBRecord = this.listLength;
                        const qty = this.selectedProductForScan.availabel;
                        this.trackingForm.controls['qty'].setValue(qty - this.listLength)
                    } else {
                        this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is already associated with other product,you can't add." });
                    }
                });
        }
    }

    saveSerializedNo(c) {
        if (this.selectedBundle) {
            this.selectedBundle.products?.forEach((element) => {
                if (element.subProductId == this.selectedProductForScan.subProductId) {
                    element.billOrderBundleSerialDetail = [];
                    this.autoGenerateLists.forEach((nl) => {
                        const obj = {
                            id: nl.id ? nl.id : 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.userId,
                            updatedBy: this.app.userId,
                            createdDate: new Date().toISOString(),
                            updatedDate: new Date().toISOString(),
                            billOrderProductId: this.selectedProductForScan?.subProductId,
                            billOrderBundleDetailId: this.selectedProductForScan?.id ? this.selectedProductForScan.id : 0,
                            barcode: nl.serialNo,
                            lotNumber: nl.lotNo,
                            revisionNumber: nl.revisionNo,
                            expirationDate: nl.expiration,
                            statusId: 1,
                        };
                        element.billOrderBundleSerialDetail.push(obj);
                    });
                }
            });
        } else {
            this.items.forEach((element) => {
                if (element.productId == this.selectedProductForScan.productId) {
                    element.vendorCreditProductSerialDetails = [];
                    this.autoGenerateLists.forEach((nl) => {
                        const obj = {
                            id: nl.id ? nl.id : 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.userId,
                            updatedBy: this.app.userId,
                            createdDate: new Date().toISOString(),
                            updatedDate: new Date().toISOString(),
                            billOrderProductId: this.selectedProductForScan.productId,
                            barcode: nl.serialNo,
                            serialNumber2: nl.serialNo2,
                            serialNumber3: nl.serialNo3,
                            serialNumber4: nl.serialNo4,
                            serialNumber5: nl.serialNo5,
                            serialNumber6: nl.serialNo6,
                            serialNumber7: nl.serialNo7,
                            serialNumber8: nl.serialNo8,
                            serialNumber9: nl.serialNo9,
                            serialNumber10: nl.serialNo10,
                            serialNumber11: nl.serialNo11,
                            serialNumber12: nl.serialNo12,
                            serialNumber13: nl.serialNo13,
                            serialNumber14: nl.serialNo14,
                            serialNumber15: nl.serialNo15,
                            serialNumber16: nl.serialNo16,
                            serialNumber17: nl.serialNo17,
                            lotNumber: nl.lotNo,
                            revisionNumber: nl.revisionNo,
                            expirationDate: nl.expiration,
                            statusId: 1,
                            referenceId: this.refId
                        };
                        element.vendorCreditProductSerialDetails.push(obj);
                    });
                }
            });
        }
        this.selectedProductForScan = null;
        this.selectedBundle = null;
        this.listLength = 0;
        this.displayScanInfo = false;
    }

    setMainHeaderTracking() {
        const checked = this.nameLists.filter((ch) => ch.checked);
        if (checked.length == this.nameLists?.length) {
            this.allChecked = true;
        } else {
            this.allChecked = false;
        }
    }

    removeNumber(i) {
        this.nameLists.splice(i, 1);
        this.autoGenerateLists.splice(i, 1);
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength--;
        const qty = this.selectedProductForScan.availabel;
        this.trackingForm.controls['qty'].setValue(qty - this.listLength)
        this.totalTBRecord = this.listLength;
    }

    deleteAll() {
        this.autoGenerateLists = [];
        this.nameLists = [];
        this.listLength = 0;
        this.totalTBRecord = 0;
        const qty = this.selectedProductForScan.availabel;
        this.trackingForm.controls['qty'].setValue(qty)
    }

    setTableCheck() {
        for (let s of this.autoGenerateLists) {
            if (this.allChecked) {
                s.checked = true;
            } else {
                s.checked = false;
            }
        }
    }
    //tracking
    openImport() {
        this.importCount = this.selectedProductForScan?.availabel;
        this.displayImport = true;
    }
    hideImport() {
        this.displayImport = false;
    }

    onCompleteSearchProduct(e) {
        const data = {
            vendorId: this.vendorCreditForm.controls["vendorId"]?.value.id,
            pageNumber: 1,
            pageSize: 15,
            searchValue: e.target.value,
        };
        this.purchaseService
            .getWarehouseWiseProductBarcode(data)
            .then((products) => {
                let { inventory, headers } = products;
                inventory = inventory == null ? [] : inventory;
                headers = headers == null ? [] : headers;
                this.scanedProductsList = this.productDataService.prepareProductsList(inventory);
                this.searchValue = "";
                this.scanedProductsList.forEach((element) => {
                    element.availabel = element.addQty;
                    element.products = element.bundleDetails;
                    element.price = element.costPrice;
                    if (element.products?.length > 0) {
                        for (let prd of element.products) {
                            prd.availabel = prd.ordQty;
                            prd.currentVal = prd.availabel;
                            prd.price = prd.costPrice;
                        }
                    }
                    const productExist = this.items.find((p) => p.id == element.id);
                    if (productExist) {
                        productExist.availabel = Number(productExist.availabel) + Number(element.addQty);
                    } else {
                        element.vendorCreditProductSerialDetails = [];
                        //element.billOrderBundleDetail=[];
                        this.items.push(element);
                    }
                    this.items.forEach((element) => {
                        element.cost = 0;
                        element.cost = element.price * element.availabel;
                        if (element.products?.length > 0) {
                            element.cost = 0;
                            for (let prd of element.products) {
                                prd.cost = 0;
                                prd.billOrderBundleSerialDetail = [];
                                //prd.availabel = prd.availabel * element.availabel;
                                prd.availabel = prd.originalQty * element.availabel * element.unit?.uomDetail?.value;
                                prd.cost = prd.price * prd.availabel;
                                element.cost = Number(element.cost) + Number(prd.cost);
                            }
                        }
                    });
                    this.calculateItemExpense();
                });
            })
            .finally(() => { });
    }

    generate() {
        if (this.isFormIncomplete) {
            this.messageService.add({ severity: "error", summary: "Error", detail: "Please fill all required fields." });
            return
        }
        const length = this.selectedProductForScan?.availabel - this.listLength;
        this.autoGenerateLists = this.utilService.autogenerateSerial(this.trackingForm.value, this.prefixValue, this.autoGenerateLists, length);
        for (let auto of this.autoGenerateLists) {
            auto.expiration = auto.expiration && new Date(auto.expiration);
        }
        this.totalTBRecord = this.autoGenerateLists.length;
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.selectedProductForScan?.availabel;
    }

    loadSerialsLazy(event) {
        if (this.autoGenerateLists) {
            this.nameLists = this.autoGenerateLists.slice(event.first, event.first + event.rows);
        }
    }

    importSerialData(data) {
        /*check whether same file is importing for all product in RPO*/
        for (let dt of data.list) {
            for (let prd of this.items) {
                const prdDuplicate = prd.vendorCreditProductSerialDetails?.filter((sNo) => prd.productId != this.selectedProductForScan.productId && sNo.barcode == dt.serialNo);
                if (prdDuplicate?.length > 0) {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "You are trying to import same serialNo for different product in RPO",
                    });
                    return;
                }
            }
        }
        if (data.action == 'add') {
            for (let dt of data.list) {
                const index = this.autoGenerateLists?.findIndex((exp) => exp.serialNo == dt.serialNo);
                if (index > -1) {
                    dt.id = this.autoGenerateLists[index].id;
                    this.autoGenerateLists[index] = dt;
                } else {
                    if (this.listLength < this.selectedProductForScan?.availabel && this.utilService.hasSerialNo(dt.serialNo, this.systemTrackingData)) {
                        this.autoGenerateLists.push(dt);
                        this.listLength++;
                    }
                }
            }
        } else {
            // Get the total quantity from the form control
            const totalQty = this.selectedProductForScan.availabel || 0;
            const uniqueList = data.list?.filter(dt => this.utilService.hasSerialNo(dt.serialNo, this.systemTrackingData));
            const filteredList = uniqueList.slice(0, totalQty);
            // Fields to skip when comparing
            const skipKeys = ['id', 'expiration', 'field1', 'field2', 'field3', 'field4', 'field5', 'field6', 'field7', 'field8',
                'field9', 'field10', 'field11', 'field12', 'field13', 'field14', 'field15', 'field16', 'field17', 'field18', 'field19',
                'field20'
            ];
            // Compare only defined + non-empty fields from newItem against existingItem
            const isMatch = (existingItem: any, newItem: any): boolean => {
                for (const key in newItem) {
                    if (skipKeys.includes(key)) continue;

                    const newVal = newItem[key];
                    if (newVal !== undefined && newVal !== null && newVal !== '') {
                        if (existingItem[key] !== newVal) return false;
                    }
                }
                return true;
            };
            // Step 1: Update existing items
            let updatedList = this.autoGenerateLists.map(existingItem => {
                const match = filteredList.find(newItem => isMatch(existingItem, newItem));
                if (match) {
                    return {
                        ...existingItem,
                        ...Object.keys(match).reduce((acc, key) => {
                            acc[key] = match[key] !== undefined && match[key] !== ''
                                ? match[key]
                                : existingItem[key]; // preserve existing if new is blank
                            return acc;
                        }, {} as any)
                    };
                }
                return existingItem;
            });
            // Step 2: Remove items not found in filteredList
            updatedList = updatedList.filter(existingItem =>
                filteredList.some(newItem => isMatch(existingItem, newItem))
            );
            // Step 3: Add new items not present in updatedList
            filteredList.forEach(newItem => {
                const exists = updatedList.some(existingItem => isMatch(existingItem, newItem));
                if (!exists) {
                    updatedList.push(newItem);
                }
            });
            this.autoGenerateLists = updatedList;
        }
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.totalTBRecord = this.listLength;
        this.disabledSave = false;
        this.displayImport = false;
        const qty = this.selectedProductForScan.availabel;
        this.trackingForm.controls['qty'].setValue(qty - this.listLength)
        this.messageService.add({
            severity: Severity.Success,
            summary: this.titlecasePipe.transform(Severity.Success),
            detail: "Import successfully,removed duplicate Serial No.",
        });
    }

    saveImport(data) {
        this.refId = data.referenceId;
        //duplicate file import
        const unique = data.list?.filter((obj) => {
            const autoIndex = this.autoGenerateLists.findIndex(item => item.serialNo === obj.serialNo);
            const hasBlankSerialNo = this.autoGenerateLists.some(item => item.serialNo === "");
            return autoIndex === -1 || hasBlankSerialNo;
        }) || [];

        const qty = (this.selectedProductForScan?.availabel - this.listLength);
        if (unique.length > 0 && (data.list?.length - unique.length) > qty) {
            this.confirmationService.confirm({
                message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
                header: "Alert Confirmation",
                icon: "pi pi-info-circle",
                accept: () => {
                    this.importSerialData(data);
                },
                reject: () => { },
            });
        } else {
            this.importSerialData(data);
        }
    }

    checkSerialNoInSystem(productId, warehouseId) {
        if (this.dialogType == "EDIT" || this.dialogType == "COPY" || this.dialogType == "VIEW") {
            this.purchaseService.checkSerialNoInSystemByVendorCreditId(warehouseId, productId, this.selectedVendorCreditId).subscribe((data) => {
                this.systemTrackingData = data;
            });
        } else {
            this.purchaseService.checkSerialNoInSystemForVendorCredit(warehouseId, productId).subscribe((data) => {
                this.systemTrackingData = data;
            });
        }
    }

    onCancelVendorCreditDialog() {
        this.onCloseVendorCreditDialog.emit("cancel");
    }

    calculateDueDate() {
        const duedate = this.utilService.getDueDate(this.vendorCreditForm.controls["paymentTermId"].value?.paymentTerm, new Date());
        const dateUser = this.app._showDateTimeWithZone(duedate);
        if (duedate) {
            this.vendorCreditForm.controls["dueDate"].setValue(dateUser);
        } else {
            const date = this.app._showDateTimeWithZone(new Date());
            this.vendorCreditForm.controls["dueDate"].setValue(date);
        }
    }

    checkRequired(name, cf_list) {
        return cf_list.find((el) => el?.name == name)?.isRequired || false;
    }

    onEnterDownStopPropagation(event) {
        event.stopPropagation();
    }

    /** Search Location */
    onSearchQueryChange(query: string) {
        if (!this.searchQuery) {
            this.filteredLocation = this.allLocationsDD;
        }
        this.filteredLocation = this.allLocationsDD?.filter(location =>
            location?.customName?.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            this.getFullAddress(location)?.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    }
    getFullAddress(location) {
        let address = '';
        if (location.address) {
            address += location?.address?.streetAddress1 ? location.address.streetAddress1 + ' ' : '';
            address += location?.address?.streetAddress2 ? location.address.streetAddress2 + ' ' : '';
            address += location?.address?.city ? location.address.city.name + ' ' : '';
            address += location?.address?.state ? location.address.state.name + ' ' : '';
            address += location?.address?.country ? location.address.country.name + ' ' : '';
            address += location?.address?.zipCode ? location.address.zipCode : '';
        }
        return address.trim();
    }

    handleTabChange(event) {
        if (event.index == 1) {
            this.glApiCall = true;
        }
        else {
            this.glApiCall = false;
        }
    }

    onPostingInfoChange(event: IPostingPeriodDetails) {
        this.updatedPostingPeriodInfo = event;
    }
    getIsetting() {
        this.appMainService.isShowSpinner("loadISettings");
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
        this.appMainService.isHideSpinner("loadISettings");
      }

    // Tax Selection
    async getTaxByAddress(countryId: number) {
        const taxData: any = await this.utilService.getTaxByCountryId(countryId);
        this.taxSettings = taxData.taxSettings ?? null;
        this.allTaxRates = taxData?.allTaxRates ?? [];
        this.taxConfig = taxData.taxConfig ?? null;
    }
    openTax(product: any) {
        this.currentProduct = product;
        this.selectedTax = product?.productSubTax ?? [];
        this.taxDialogContext = 'product';
        this.displayTaxSelectionDialog = true;
    }

    openFooterTax() {
        const allTaxes = this.items?.flatMap((product) => {
            return product.productSubTax || [];
        });
        this.selectedTax = this.getUniqueTaxes(allTaxes);
        this.taxDialogContext = 'footer';
        this.displayTaxSelectionDialog = true;
    }

    private getUniqueTaxes(taxes: any[]): any[] {
        const uniqueTaxMap = new Map();
        taxes?.forEach((tax) => {
            if (!uniqueTaxMap.has(tax.taxId)) {
                uniqueTaxMap.set(tax.taxId, tax);
            }
        });
        return Array.from(uniqueTaxMap.values());
    }

    getTaxId(tax: any,productId: number) {
        return this.vendorCreditDetails?.vendorCreditProducts?.find(item => item.productId == productId)?.vendorCreditProductSubTax?.find(sTax => sTax.taxId == tax.taxId)?.id ?? 0;
    }

    applyTax(event: TaxSelectionModel) {
        this.displayTaxSelectionDialog = false;
        this.selectedTax = null;
        if (this.taxDialogContext === 'product') {
            this.currentProduct.productSubTax = event.selectedTaxes;
            this.currentProduct.isManualTaxApplied = true;
            this.calculateSubTotal(this.currentProduct, this.currentProduct.availabel, this.currentProduct.price);
        } else if (this.taxDialogContext === 'footer') {
            this.items = this.items.map(product => ({
                ...product,
                productSubTax: event.selectedTaxes,
                isManualTaxApplied: true
            }));
            this.items?.forEach((item) => {
                let productsTotalTax = 0;
                item?.productSubTax?.forEach((sTax) => {
                    productsTotalTax += this.utilService.calculateProductsTax(sTax.taxRate, item.cost);
                });
                item.taxAmount = productsTotalTax;
            })
            this.findsum();
        }
    }

    onCloseTaxSelectionDialog(event: any) {
        this.displayTaxSelectionDialog = false;
    }
    // End of Tax Selection

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
